// extracted by mini-css-extract-plugin
export default {"download-button":"DownloadApp_download-button__LzDkM"};